export default __webpack_public_path__ + "static/media/Myracle tutorial_v1.0_EN_low quality.bb4f7ca1.mp4";